// 分馆列表
const qaBranchList = resolve =>
  require(['../../../views/qa/qaBranchList'], resolve)

// 创建分馆
const qaBranchCreate = resolve =>
  require(['../../../views/qa/qaBranchCreate'], resolve)

// 协同认证
const qaBranchCollaborateAuth = resolve =>
  require(['../../../views/qa/qaBranchCollaborateAuth'], resolve)

// 邀请认证
const qaBranchInviteAuth = resolve =>
  require(['../../../views/qa/qaBranchInviteAuth'], resolve)

// 馆长管理中心
const qaBranchAdmin = resolve =>
  require(['../../../views/qa/qaBranchAdmin'], resolve)

// 领取补贴
const qaReceiveSubsidy = resolve =>
  require(['../../../views/qa/qaReceiveSubsidy'], resolve)

// 心理小店
const qaPsychologicalShop = resolve =>
  require(['../../../views/qa/qaPsychologicalShop'], resolve)

export default [
  {
    path: '/qaBranchList',
    component: qaBranchList
  },
  {
    path: '/qaBranchCreate',
    component: qaBranchCreate
  },
  {
    path: '/qaBranchCollaborateAuth',
    component: qaBranchCollaborateAuth
  },
  {
    path: '/qaBranchInviteAuth',
    component: qaBranchInviteAuth
  },
  {
    path: '/qaBranchAdmin',
    component: qaBranchAdmin
  },
  {
    path: '/qaReceiveSubsidy',
    component: qaReceiveSubsidy
  },
  {
    path: '/qaPsychologicalShop',
    component: qaPsychologicalShop
  }
]



// WEBPACK FOOTER //
// ./src/router/page/qa/index.js